module.exports = __webpack_public_path__ + "img/Bongo_logo 1.053b75a1.png";